import React, { useEffect, useState } from 'react';
import { useLocation} from 'react-router-dom';
import MyApi,{ baseURL }  from './MyApi';

import { isEmptyObject } from 'jquery';
import { Modal, Button } from 'react-bootstrap'
import {
  TreeGridComponent, ColumnsDirective, ColumnDirective, Inject, Toolbar,
  ExcelExport, Freeze, Resize, Sort, Filter } from '@syncfusion/ej2-react-treegrid';
import { L10n, setCulture, Ajax , getValue } from '@syncfusion/ej2-base';
import { useTranslation } from 'react-i18next';


import DAstats from './DAstats';
import DAByTbStats from './DAByTbStats';


setCulture('ar');
L10n.load({
  'fr-FR': {
    'treegrid': {
      "EmptyRecord": "Aucun enregistrement à afficher",
      "Excelexport": "Excel-Export",
      "Csvexport": "CSV-Export",
      "Print": "Imprimer",
      "Search": "Recherche",
      "Clear": "Effacer la recherche",
    }
  },
  'ar-AE': {
    'treegrid': {
      "EmptyRecord": "لا توجد معطيات لعرضها",
      "Excelexport": "تصدير_Excel",
      "Csvexport": "تصدير_CSV",
      "Print": "طباعة",
      "Search": "بحث",
      "Clear": "مسح البحث",
    }
  }
});

let treegridInstance = TreeGridComponent;

let nameOfFile = "Budget_depense";

let collapsedStatePersist = true;


let toolbarClick = (args) => { 
  switch (args.item.id) {
    case treegridInstance.grid.element.id + '_excelexport':
      let excelExportProperties = {
        isCollapsedStatePersist: collapsedStatePersist,
        fileName: nameOfFile + '.xlsx',
        theme: {
          header: {
            fontSize: 16,
            bold: true,
            fontColor: "#007EDC"
          },
          record: {
            fontSize: 14,
            bold: true,
            fontColor: "#000000"
          }
        },
        header: {
          headerRows: 1,
          rows: [{
            cells: [{
              colSpan: 15,
              value: nameOfFile,
              style: { fontSize: 18, hAlign: "Center", bold: true, fontColor: "#F40007" }
            }]
          }]
        },
        footer: {
          footerRows: 1,
          rows: [{
            cells: [{
              colSpan: 15,
              value: "SUIFI",
              style: { fontSize: 18, hAlign: "Center", bold: true, fontColor: "#940004" }
            }]
          }]
        },

      };
      treegridInstance.excelExport(excelExportProperties);
      break;
    case treegridInstance.grid.element.id + '_csvexport':
      let csvExportProperties = {
        isCollapsedStatePersist: collapsedStatePersist,
        fileName: nameOfFile + '.csv',
      };
      treegridInstance.csvExport(csvExportProperties);
      break;
    case 'ExpandAll':
      if (!isEmptyObject(treegridInstance.dataSource)) {
        treegridInstance.expandAll()
      }

      break;
    case 'CollapseAll':
      if (!isEmptyObject(treegridInstance.dataSource)) {
        treegridInstance.collapseAll();
      }

      break;
    default:
    // do nothing
  }
}



let getExpandedRowKeysFunction= (args) => {
  treegridInstance.expandAtLevel(1);
  
}

  


let rowDataBound = (args) => {
if (args.data.level === 0) {
      args.row.classList.add('level0'); 
  }
else if (args.data.level === 1) {
  args.row.classList.add('level1'); 
}
else if (args.data.level === 2) {
args.row.classList.add('level2'); 
} 
else if (args.data.level === 3) {
args.row.classList.add('level3'); 
} 
else if (args.data.level === 4) {
args.row.classList.add('level4'); 
} 
else if (args.data.level === 5) {
args.row.classList.add('level5'); 
}  
}


function DepenseGrid() {

  
  
  

  const { t,i18n } = useTranslation()
  const currentLanguageCode = i18n.language
  const [listYears, setListYears] = useState([]);
  const [sortingOptions] = useState(   {columns: [{ field: 'Reference', direction: 'Ascending' }]});
  const [tb, setTb] = useState(null);
  const [article, setArticle] = useState(null);
  const [reference, setReference] = useState(null);

 

  const [isShow, setShow] = useState(false)
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [typeChart, setTypeChart] = useState('line');
    
  useEffect(() => {


 
    const fetchYears = async () => {
      MyApi.get('/getAllYearDepenseDesc').then(result => {
       const res = result.data;
       setListYears(res);
     });
    }
    fetchYears();



  function loadData () {
  
    try {
      const ajax = new Ajax(baseURL +'/getDepenseTable/', "GET");
      treegridInstance.showSpinner();
      const treegrid = treegridInstance;
      ajax.send();
      ajax.onSuccess = (data) => {
        treegrid.hideSpinner();
        treegrid.dataSource = JSON.parse(data);
       
      };
    } catch (err) {
      console.error(err.message);
    }
  }
  
  if (listYears.length > 0) {
 
  loadData();
}

let chartTypeValue = document.getElementById('chartTypeValue');
setTypeChart(chartTypeValue.value); 
  if(chartTypeValue){
   chartTypeValue.addEventListener("change", () => {
   setTypeChart(chartTypeValue.value); 
 });
 }


} , [listYears.length]);

let doubleClick= (args) => {
  let taskId = getValue('TaskID', args.rowData); 
  let article = getValue(currentLanguageCode === 'fr'? 'Libelle':'Libelle_ar', args.rowData);
  let reference = getValue('Reference', args.rowData);  
  setTb(taskId);
  setArticle(article);
  setReference(reference);
     handleShow();
 }


  return (


    <div className="row">




<Modal show={isShow} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title> {article} <i className='fa fa-certificate'></i> {reference}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          
        <DAByTbStats currentLanguageCode={currentLanguageCode} tb = {tb} article = {article} reference = {reference} typeChart={typeChart}/>

        </Modal.Body>


        <Modal.Footer>
          <Button variant="danger" onClick={handleClose}>
           <i className='fa fa-close'> </i> {t('fermer')}
          </Button>
        </Modal.Footer>
      </Modal>


<DAstats currentLanguageCode={currentLanguageCode} typeChart={typeChart}/>





<div className="col-md-12"><hr /></div>



      <div className="col-md-12 pad5">



        <TreeGridComponent ref={treegrid => treegridInstance = treegrid} hasChildMapping='IsParent' height="720" idMapping='TaskID'
          parentIdMapping='ParentItem' treeColumnIndex={0} allowPaging={false}
          allowExcelExport={true} enableHover={true} frozenColumns={2}
          toolbar={['Print', 'ExcelExport', 'CsvExport', 'Search', { text: t('ouvrir_tout'), tooltipText: t('ouvrir_tout'), prefixIcon: "e-expand", id: "ExpandAll" },
           { text: t('fermer_tout'), tooltipText: t('fermer_tout'), prefixIcon: "e-collapse", id: "CollapseAll" }]} toolbarClick={toolbarClick}
          allowResizing={true} allowSorting={true} enableCollapseAll={true} locale={currentLanguageCode === 'fr'? "fr-FR":"ar-AE"}
          enableRtl={currentLanguageCode=== 'fr'? false:true}  dataBound={getExpandedRowKeysFunction} rowDataBound={rowDataBound} sortSettings={sortingOptions}
          recordDoubleClick={doubleClick}>
          <Inject services={[Toolbar, ExcelExport, Freeze, Resize, Sort, Filter, Sort]} />
          
          <ColumnsDirective>
         
            <ColumnDirective field={currentLanguageCode === 'fr'? 'Libelle':'Libelle_ar'} headerText={t('rubrique')} textAlign={currentLanguageCode=== 'fr'? 'Left':'Right'} width='430'></ColumnDirective>
            <ColumnDirective field="Reference" headerText={t('article')} textAlign="Left" width='140' ></ColumnDirective>
           
          
            {listYears && listYears.map((item, index) => 
            
            <ColumnDirective  key={index.toString()}
              headerText={item.year} textAlign='Center'
              columns={[{ field: 'Prev_'+item.year, headerText: t('previsionnel2'), width: 155, textAlign: 'Right' },
                        { field: 'Real_'+item.year, headerText: t('realiser'), width: 155, textAlign: 'Right' }
              ]} >
            </ColumnDirective>
            
           )}
           
          
          </ColumnsDirective>
        </TreeGridComponent>


      </div>

    </div>


  );
}

export default DepenseGrid;
